import { Box, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as RefreshIcon } from '../../assets/images/refresh.svg';
import { useState } from 'react';

import PcTokenSupplyStatus from '../tokensItem/pc/PcTokenSupplyStatus';
import MobileTokenSupplyStatus from '../tokensItem/mobile/MobileTokenSupplyStatus';
import { Notice } from '../tokensItem/tokenSupplyStatus/CommonComponent';

const TokenSupplyStatus = ({ type }: { type: string }) => {
  const isMobile = useMediaQuery('(max-width:900px)');
  const [time, setTime] = useState(new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: true }));

  return (
    <Box mt={{ xs: '68px', md: '77.17px' }}>
      <Typography variant="h3" color="#242424">
        Token Supply Status
      </Typography>

      <Box
        mt="20px"
        sx={{
          background: '#D9D9D91A',
          borderRadius: '20px',
          pt: { xs: '16px', md: '21px' },
          pb: { xs: '18px', md: '43px' },
          pl: { xs: '16px', md: '54px' },
          pr: { xs: '16px', md: '51.63px' },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} mb={{ xs: '24px', md: '41.47px' }}>
          <Box
            sx={{
              display: 'flex',
              gap: '6px',
              alignItems: 'center',
              height: '14px',
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: '9px', md: '12px' },
                lineHeight: { xs: '11px', md: '14px' },
                letterSpacing: 0,
                color: '#5D5D5D',
              }}
            >
              Standard Time: {time}
            </Typography>
            <div
              onClick={() => {
                setTime(new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: true }));
              }}
            >
              <RefreshIcon width={isMobile ? 6 : 8} height={isMobile ? 6 : 8} color={'#5D5D5D'} />
            </div>
          </Box>
        </Box>
        {/* PC 화면 */}
        <PcTokenSupplyStatus type={type} />
        {/* 모바일 화면 */}
        <MobileTokenSupplyStatus type={type} />
      </Box>
      <Notice type={type} />
    </Box>
  );
};

export default TokenSupplyStatus;
